/**
 * Go through cart checkout block extention woocommerce documentation for more details.
 *
 * @see https://github.com/woocommerce/woocommerce/blob/trunk/docs/cart-and-checkout-blocks/available-slot-fills.md#experimentalordershippingpackages
 */
import { registerPlugin } from '@wordpress/plugins';
import { ExperimentalOrderShippingPackages } from '@woocommerce/blocks-checkout';
import { RawHTML } from '@wordpress/element';
import './index.scss';

const ShippingMessageContainer = ( props ) => {
    const { extensions } = props;
    if ( ! extensions || ! extensions.dokan_shipping ) {
        return;
    }
    const { messages } = extensions.dokan_shipping;

    if ( ! messages.length ) {
        return;
    }

    return (
        <div className="dokan-shipping-remaining-amount">
            { messages.map( ( message, index ) => {
                return (
                    <RawHTML
                        className="dokan-shipping-remaining-amount-list"
                        key={ index }
                    >
                        { message }
                    </RawHTML>
                );
            } ) }
        </div>
    );
};

const render = () => {
    return (
        <ExperimentalOrderShippingPackages>
            <ShippingMessageContainer />
        </ExperimentalOrderShippingPackages>
    );
};

registerPlugin( 'dokan', {
    render,
    scope: 'woocommerce-checkout',
} );
